import axios from 'axios';

/**
 * Backend domain code for "the account holds no membership in the organization
 * being addressed" (`AUTH_NO_MEMBERSHIP`, 11009). Raised by login when a user
 * belongs to no workspace at all, and by `ActiveMembershipGuard` on every
 * request once a member is removed mid-session.
 */
export const NO_MEMBERSHIP_ERROR_CODE = 'AUTH_NO_MEMBERSHIP';

interface IDomainErrorBody {
    readonly error?: { readonly code?: string };
}

/**
 * Narrow test for that one code. Deliberately not a bare 403 check — ordinary
 * permission denials share the status and must keep the session alive.
 */
export function isNoMembershipError(error: unknown): boolean {
    if (!axios.isAxiosError(error)) return false;
    const data: unknown = error.response?.data;
    if (!data || typeof data !== 'object') return false;
    return (data as IDomainErrorBody).error?.code === NO_MEMBERSHIP_ERROR_CODE;
}
